import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePinInputClass;
function SavePinInput() {
  if (SavePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId, icon, name) {
        this.a6s_1 = partyId;
        this.b6s_1 = pinId;
        this.c6s_1 = icon;
        this.d6s_1 = name;
      }
      toString() {
        return 'SavePinInput(partyId=' + this.a6s_1.toString() + ', pinId=' + this.b6s_1.toString() + ', icon=' + this.c6s_1 + ', name=' + this.d6s_1 + ')';
      }
      hashCode() {
        var result = this.a6s_1.hashCode();
        result = imul(result, 31) + this.b6s_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.c6s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.d6s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinInput()))
          return false;
        if (!this.a6s_1.equals(other.a6s_1))
          return false;
        if (!this.b6s_1.equals(other.b6s_1))
          return false;
        if (!(this.c6s_1 === other.c6s_1))
          return false;
        if (!(this.d6s_1 === other.d6s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinInput');
    SavePinInputClass = $;
  }
  return SavePinInputClass;
}
//region block: exports
export {
  SavePinInput as SavePinInputnc3r3ek8pldn,
};
//endregion

//# sourceMappingURL=SavePinInput.mjs.map
